import IssCaseView from './views'

export default IssCaseView



// WEBPACK FOOTER //
// ./src/iss-cases/details/index.js